import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PriceCurrencyPipe } from '@/common/pipes/price-currency.pipe';
import { PriceFormatPipe } from '@/common/pipes/price-format.pipe';
import { DriversSalaryV2StateService } from '../_services/drivers-salary-v2.state.service';
import { parsePriceToGrosze } from '../_utils/drivers-salary-v2.utils';

@Component({
	selector: 'app-salary-summary',
	standalone: true,
	imports: [
		CommonModule,
		MatButtonModule,
		MatCardModule,
		MatFormFieldModule,
		MatInputModule,
		MatProgressSpinnerModule,
		PriceCurrencyPipe,
		PriceFormatPipe,
	],
	templateUrl: './salary-summary.component.html',
	styleUrl: './salary-shared.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalarySummaryComponent {
	readonly state = inject(DriversSalaryV2StateService);

	onTransferPlnBlur(target: HTMLInputElement): void {
		this.state.overrideTransferPln.set(parsePriceToGrosze(target.value));
		this.state.saveOverrides();
	}

	onCashPlnBlur(target: HTMLInputElement): void {
		this.state.overrideCashPln.set(parsePriceToGrosze(target.value));
		this.state.saveOverrides();
	}

	onCashEurBlur(target: HTMLInputElement): void {
		this.state.overrideCashEur.set(parsePriceToGrosze(target.value));
		this.state.saveOverrides();
	}
}
